import React from 'react'
import { Carousel } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import SlideData from '../.././../data/Slide.json';

function Slide() {
    return (
        <Carousel fade>
            {
                SlideData.map((data) => (
                    <Carousel.Item>
                        <img
                            className='slide-carl'
                            src={data.backgroundImage}
                            alt="First slide"
                        />
                        <Carousel.Caption >
                            <h3 className='slide-cap'> {data.title} </h3>
                            <p className='slide-cap1'> {data.desc} </p>
                            <div className='slide-cap-links' >
                                <a href={data.quoteData} className='slide-link'> {data.link} </a>
                                {/* <Link to={data.link2} className='slide-link1'> {data.otherlink} </Link> */}
                            </div>
                        </Carousel.Caption>
                    </Carousel.Item>

                ))
            }
        </Carousel>
    )
}

export default Slide
